import { Group, ProfileSuggestion, UserProfile } from 'api';

interface ICreateGroupModeratorResponse {
  groupId: Group['id'];
  moderator: ProfileSuggestion;
  currentUser: UserProfile;
}

export const createGroupModeratorResponse = ({
  groupId,
  moderator,
  currentUser,
}: ICreateGroupModeratorResponse) => ({
  createGroupModerator: {
    added_by_user_id: currentUser.id,
    created_at: Date.now(),
    group_id: groupId,
    user: moderator,
    user_id: moderator.id,
    full_name: moderator.title,
    __typename: 'GroupModerator',
  },
});
